import register from '@kpsys/angularjs-register';
import {customElementsConfig} from './custom-elements.config';


export default register('portaro.custom-elements-module', )
    .run(customElementsConfig)
    .name()